<template>
    <div class="overflow-auto">
        <div class="input-group mt-0 mb-4 align-items-stretch">
			<button class="input-group-prepend search-icon" @click="doSearch">
				<img :src="`${publicPath}/img/gep/icon/search.svg`">
			</button>
            <input type="text" :placeholder="$t('Search')" class="form-control no-border pl-2" v-model="search" v-on:keyup.enter="doSearch">
		</div>

        <div class="block-account p-3 mb-3 mt-1" v-for="item in beneficiaryList">
            <div class="d-flex align-items-center">
                <img :src="`${publicPath}/img/gep/user.svg`" width="50px">
                <div class="px-3 d-flex flex-column">
                    <div class="fz-20 fw-700">{{ item.accountName }}</div>
                    <div class="fz-14 fw-400 text-grey7">{{ item.userNo }}</div>
                </div>
            </div>
        </div>

        <div v-if="isLoading" class="dot-loading mt-3">
            <ul class="loader-circle">
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    </div>
    
  </template>
  
  <script>

    import Withdrawal from "@/services/Withdrawal";
 
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        isLoading:false,
        userType:'2',
        data:[],
        search:'',
        currentPage : 1,
	    perPage : 10,
        beneficiaryList : [{
            "accountName":"Rogayah Najibah",
            "userNo":"1234567890"
        }]
      };
    },
    props:['userNo'],
    methods: {
        doSearch(){
            let self = this;
            var opt = {
                userNo              : this.userNo,
                page  				: this.currentPage,
                pagesize 			: this.perPage,
                sort				: "-updated_at"
            };

            Withdrawal.beneficiaryList(opt).then((response)=>{
                if (response.status == 200) {
                    self.beneficiaryList = response.data;
                }
            });
        },
        checkError(err){
            const response = err.response;
            try{
                if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                        path: '/login', 
                        });
                    }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }catch(e){
                console.log(err);
            }        
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.doSearch();
        });
    },
    destroyed() {
      
    },
  };
  </script>
  
<style scoped>
.block-account{
    background: #F8F9FA;
    border-radius: 8px;
}
</style>